import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import '../../fonts/NotoSansJP-Bold-normal';
import '../../fonts/NotoSansJP-Regular-normal';

//-----------------------------------------------
// PDF生成
//-----------------------------------------------
export function generateDailyReportPDF({
    entryDate,
    userName,
    haccpMasta,
    dairyData,
    checkData,
    userList
}) {
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
    });
    // フォント設定
    doc.setFont('NotoSansJP-Regular');

    // チェックデータ
    drawHeader(doc, entryDate, userName, "日報");
    drawCheckedData(doc, haccpMasta, dairyData, checkData, userList);

    // 画面表示
    const newWindow = window.open('', '_blank');

    requestAnimationFrame(() => {
        const pdfBlob = doc.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);

        newWindow?.location.assign(pdfUrl);
    });
};

//-----------------------------------------------
// PDF生成（月報）
//-----------------------------------------------
export function generateMonthlyReportPDF({
    userName,
    monthlyData,
    monthlyItemCheckData,
    haccpMasta,
    targetMonth
}) {
    const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
    });
    // フォント設定
    doc.setFont('NotoSansJP-Regular');

    // チェックデータ
    drawHeader(doc, targetMonth, userName, "月報")
    drawMonthCheckData(doc, monthlyData, monthlyItemCheckData, haccpMasta, targetMonth)

    // 画面表示
    const newWindow = window.open('', '_blank');

    requestAnimationFrame(() => {
        const pdfBlob = doc.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);

        newWindow?.location.assign(pdfUrl);
    });
};
// ----------------------------------------------
// function - ヘッダー描画
//-----------------------------------------------

function drawHeader(doc, displayDate, userName, type) {
    const pageWidth = doc.internal.pageSize.getWidth();
    // タイトル
    doc.setFontSize(16);
    doc.text(`${type}データ`, pageWidth / 2, 20, { align: 'center' });
    doc.setFontSize(10);
    doc.text(`登録者: ${userName}`, 10, 30);
    doc.text(displayDate, pageWidth - 20, 30, { align: 'right' });
}
// ----------------------------------------------
// function - チェックデータ描画
//-----------------------------------------------
function drawCheckedData(
    doc,
    haccpMasta,
    dairyData,
    checkData,
    userList
) {
    const getUserName = (targetUsetId) =>{
        return userList?.find(users => String(users.userId) === String(targetUsetId))?.name;
    }
    const formatMMddHHmm = (date) =>{
        return (date ?? "").length !== 14 ? "" : date.substr(4, 2) +"/" + date.substr(6, 2) + " " + date.substr(8, 2) +":" + date.substr(10, 2);
    };
    const getCheckMark = (value) => {

        switch (value) {
            case 1:
                return '〇';
            case 0:
                return '×';
            case '':
            default:
                return '';
        }
    };
    checkData?.Data?.forEach(data =>{
        if (!haccpMasta.some(item => data.code && item.code == data.code)) {
            haccpMasta.push({"code":data.code,"name":data?.haccpName});
        }
    })
    doc.text(`最終入力日時:${formatMMddHHmm(dairyData?.Data[0]?.updateDatetime) ??"      "}      最終入力者:${getUserName(dairyData?.Data[0]?.updateUserId)??"    "}     承認者:${dairyData?.Data[0]?.hygieneStatus == 9 ? dairyData.Data[0]?.approvedUser : ""} `,15,35)
    haccpMasta.forEach(haccp => {
        const startY = doc?.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 15 : 45;
        doc.text(`${haccp.name}`, 20, startY-3);
        const head = [[
            { content: '入力時刻' },
            { content: '結果' },
            { content: '記録内容' },
            { content: '入力者' },
        ]];
        const body = [];

        const reportlist = checkData?.Data?.filter(
            report => report?.code == haccp?.code
        );
        reportlist?.forEach(report=>{
            const row = [formatTime(report.updateDatetime.slice(8,16)),getCheckMark(report.checkStatus),report.textx1,getUserName(report.updateUserId)]
            body.push(row)
        });

        if(body.length ===0){
            body.push("")
        }

        autoTable(doc, {
            startY: startY,
            head: head,
            body: body,
            theme: 'grid',
            styles: {
                font: 'NotoSansJP-Regular', // 全体のフォント
                fontSize: 9,
                cellPadding: 2
            },
            headStyles: {
                font: 'NotoSansJP-Bold',
                fontSize: 10,
                fillColor: [200, 200, 200],
                halign: 'center',
                fontStyle: 'normal'
            },
            columnStyles:{
                0: { halign: 'center', cellWidth: 20 },
                1: { halign: 'center', cellWidth: 20 },
                2: { cellWidth: 110 },
                3: { halign: 'center', cellWidth: 30 },
            },
        });
    });

}

// ----------------------------------------------
// function - 月のチェックデータ描画
//-----------------------------------------------
function drawMonthCheckData(doc, monthlyData,monthlyItemCheckdata,haccpMasta,targetMonth) {
    const toCheckMark = (value) => {
        switch (value) {
            case 1:
                return '〇';
            case 0:
                return '×';
            case '':
            default:
                return '';
        }
    };
    const toComfirmCheckMark = (value) => {
        switch (value) {
            case 9:
                return '〇';
            case '':
            default:
                return '';
        }
    };
    const dayMap = {};
    const dayItemMap = {};
    monthlyData?.Data?.forEach(d => {
        dayMap[d.entryDate] = d;
    });

    const masterList = Array.isArray(haccpMasta) ? haccpMasta : [];

    monthlyItemCheckdata?.Data?.forEach(datas => {
        datas?.forEach(data => {
            const key = `${data?.hygieneId}_${data?.seq}`;
            if (!dayItemMap[key]) {
                dayItemMap[key] = [];
            }
            if (!masterList.some(item => data.code && item.code == data.code)) {
                masterList.push({"code":data.code,"name":data?.haccpName});
            }
            dayItemMap[key].push(data);
        })
    });

    const [year, month] = targetMonth?.split('-').map(Number);
    const lastDay = new Date(year, month, 0).getDate(); // 月末日
    doc.setFont('NotoSansJP-Regular');

    // ===== ヘッダー =====

    const head = [[
        { content: '日付' },
        { content: '曜日' },
        { content: '承認' },
        { content: '時刻' },
        ...masterList.map(m => ({
            content: verticalText(m?.name),
            styles: {
                halign: 'center',
                valign: 'top',
            }
        }))
    ]];
    const columnStyles = {
        0: { cellWidth: 20 },
        1: { cellWidth: 10 },
        2: { cellWidth: 10 },
        3: { cellWidth: 12 },
    };

    masterList.forEach((_, i) => {
        columnStyles[i + 4] = { cellWidth: 8 };
    });

    // ===== ボディ =====
    const body = [];
    for (let day = 1; day <= lastDay; day++) {
        
        const itemKeys = Object.keys(dayItemMap);
        const dateStr = `${year}${String(month).padStart(2, '0')}${String(day).padStart(2, '0')}`;
        const dayData = dayMap[dateStr];
        const dayItemKeys = itemKeys
            .filter(item => item.includes(dayData?.hygieneId))
            .sort((a, b) => {
                const seqA = Number(a?.split('_')[1]);
                const seqB = Number(b?.split('_')[1]);
                return seqA - seqB;
            });

        // 曜日算出
        const weekday = ['日', '月', '火', '水', '木', '金', '土']
        [new Date(year, month - 1, day).getDay()];

        if (!dayData || dayData?.length === 0 || !dayItemKeys || dayItemKeys?.length === 0) {
            // ===== データなし日：空行を1行 =====
            body.push([
                day,
                weekday,
                '',
            ]);
            continue;
        }

        // ===== データあり日：レポート分行を出す =====
        dayItemKeys.forEach( (itemKey,index) =>{
            const row = [];
            const dayItemData = dayItemMap[itemKey]
            const dataMap = new Map();
            if(index === 0){
                row.push(
                    day,
                    weekday,
                    toComfirmCheckMark(dayData.hygieneStatus),
                    formatTime(dayItemData[0].updateDatetime.slice(8,16)),
                );
            }else{
                row.push(
                    "",
                    "",
                    "",
                    formatTime(dayItemData[0].updateDatetime.slice(8,16)),
                )
            }
            

            dayItemData?.forEach(data => {
                if (data?.code && data?.checkStatus !== "") {
                    dataMap.set(data.code, data);
                }
            });

            masterList.forEach(m => {
                const data = dataMap.get(`${m.code}`);

                if (data && data?.checkStatus !== "") {
                    row.push(toCheckMark(data.checkStatus));
                } else {
                    row.push("");
                }
            });
            body.push(row);
        })
    }

    autoTable(doc, {
        startY: 35,
        head,
        body,
        theme: 'grid',

        styles: {
            font: 'NotoSansJP-Regular',
            fontSize: 8,
            halign: 'center',
            valign: 'middle',
            cellPadding: 2
        },

        headStyles: {
            font: 'NotoSansJP-Bold',
            fontSize: 9,
            fillColor: [180, 180, 180],
            fontStyle: 'normal',
            halign: 'center',
        },

        columnStyles: columnStyles,

        horizontalPageBreak: true,
        horizontalPageBreakBehaviour: 'immediately',
        horizontalPageBreakRepeat: [0,1,2,3],
    });
}
//-----------------------------------------------
// Function - 時間変換
//-----------------------------------------------
const formatTime = (time) => {
    if (time === null || time === undefined) return "";
    const t = String(time).padStart(6, "0");
    return `${t.substring(0, 2)}:${t.substring(2, 4)}`;
};
//-----------------------------------------------
// Function - 縦書きテキスト変換
//-----------------------------------------------
const verticalText = (text) => text?.split('').join('\n');